var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgListImagesView = function SvgListImagesView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12 4v16m8-9.463h-8m0 3.486H4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 4.5,
    y: 4.5,
    stroke: "#fff",
    rx: 0.5
  })));
};
export { SvgListImagesView as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Ik0xMiA0djE2bTgtOS40NjI4aC04bTAgMy40ODYzSDQiIHN0cm9rZT0iI2ZmZiIvPjxyZWN0IHg9IjQuNSIgeT0iNC41IiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHJ4PSIuNSIgc3Ryb2tlPSIjZmZmIi8+PC9zdmc+";